import * as types from '../actions/StatisticsActionTypes';
import InitialState from './InitialState';
import { assign } from '../../../shared/Assign';

export default function statisticsReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.NEW_STATISTICS_SEARCH: {
            const newState = assign({}, state);
            newState.newSearch = action.result;
            return newState;
        }

        case types.STATISTICS_SEARCH: {
            const newState = assign({}, state);
            newState.search = action.result;
            return newState;
        }

        case types.STATISTICS_RESET:
            return InitialState;

        default:
            return state;
    }
}
